module.exports = __webpack_public_path__ + "img/db-3.15a2031f.png";